import React, { useEffect, useState } from "react";
import BackArrowIcon from "../../../../components/Icons/BackArrowIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import { toast } from "react-toastify";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { Spinner } from "reactstrap";
import moment from "moment";

export default function AddLeaveSetting() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
    control,
  } = useForm();
  const location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    MonthValue: null,
  });
  const totalLeavePerMonth = watch("totalLeavePerMonth");

  const onSubmit = (data) => {
    const postData = {
      type: data?.leaveType,
      applicableFrom: data?.applicableFrom,
      totalLeavePerMonth: data?.totalLeavePerMonth,
      totalLeavePerYear: data?.totalLeavePerYear,
      yearCarryForward: data?.yearlyCarryForward,
    };

    const option = {
      method: "POST",
      data: postData,
    };

    setIsLoading(true);

    const endPoint = location?.state?.EditData
      ? apiUrl.update_leave_setting +
        `?leaveId=${location?.state?.EditData?.id}`
      : apiUrl.add_leave_setting;

    callApi(endPoint, option)
      .then((res) => {
        if (res?.status === true) {
          toast.success(res?.message);
          navigate(-1);
          reset();
        } else {
          toast.error(res?.message);
        }
      })
      .catch(() => {
        toast.error("An error occurred");
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (location?.state?.EditData) {
      setValue("leaveType", location?.state?.EditData?.leaveType);
      setValue(
        "applicableFrom",
        moment(location?.state?.EditData?.applicableFrom).format("YYYY-MM-DD")
      );
      setValue(
        "totalLeavePerMonth",
        location?.state?.EditData?.totalLeavePerMonth
      );
      setValue(
        "totalLeavePerYear",
        location?.state?.EditData?.totalLeavePerYear
      );
      setValue(
        "yearlyCarryForward",
        location?.state?.EditData?.yearCarryForward
      );
      setDisabled(false);
      setState((pre) => ({
        ...pre,
        MonthValue: location?.state?.EditData?.totalLeavePerYear,
      }));
    } else {
      reset();
    }
  }, []);

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.EditData ? "Edit" : "Add"} Leave Configuration
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="leaveType" className="form-label">
                      Leave Type
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Leave Type (e.g., Sick Leave)"
                      {...register("leaveType", {
                        required: "Leave Type is required",
                        validate: (value) => {
                          const trimmed = value.trim();
                          return (
                            trimmed.length > 0 ||
                            "Leave Type is required"
                          );
                        },
                      })}
                    />

                    {errors.leaveType && (
                      <div className="form-text text-danger">
                        {errors.leaveType.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="applicableFrom" className="form-label">
                      Applicable From
                    </label>
                    <Controller
                      name="applicableFrom"
                      control={control}
                      rules={{
                        required: "Applicable From date is required",
                      }}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="applicableFrom"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    {errors.applicableFrom && (
                      <div className="form-text text-danger">
                        {errors.applicableFrom.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Total Leave Per Month
                    </label>
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      id="totalLeavePerMonth"
                      className="form-control"
                      placeholder="Enter total leave per month"
                      {...register("totalLeavePerMonth", {
                        required: "This field is required",
                        valueAsNumber: true,
                      })}
                      onChange={(e) => {
                        const monthlyLeave = parseFloat(e.target.value || 0);
                        if (monthlyLeave > 0) {
                          setDisabled(false);
                          setValue("totalLeavePerYear", monthlyLeave * 12);
                          setState((pre) => ({
                            ...pre,
                            MonthValue: monthlyLeave * 12,
                          }));
                        } else {
                          setValue("totalLeavePerYear", "");
                          setDisabled(true);
                        }
                      }}
                      min={0}
                    />
                    {errors.totalLeavePerMonth && (
                      <div className="form-text text-danger">
                        {errors.totalLeavePerMonth.message}
                      </div>
                    )}
                  </div>
                </div>

                {/* Total Leave Per Year */}
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerYear" className="form-label">
                      Total Leave Per Year
                    </label>
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      id="totalLeavePerYear"
                      className="form-control"
                      placeholder="Enter total leave per year"
                      {...register("totalLeavePerYear", {
                        required: "This field is required",
                        valueAsNumber: true,
                        validate: (value) =>
                          value >= (totalLeavePerMonth || 0) * 12 ||
                          "Yearly leave must be greater than or equal to monthly leave times 12",
                      })}
                      min={state?.MonthValue}
                      disabled={disabled}
                    />
                    {errors.totalLeavePerYear && (
                      <div className="form-text text-danger">
                        {errors.totalLeavePerYear.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
                    Yearly carry forward
                  </h4>
                  <div className="form-group mb-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        {...register("yearlyCarryForward")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="yearlyCarryForward"
                      >
                        Yes
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-3">
                <button
                  className="btn btn-secondary px-5"
                  type="button"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary px-5">
                  {isLoading ? (
                    <Spinner />
                  ) : location?.state?.EditData ? (
                    "Edit Leave Configuration"
                  ) : (
                    "Add Leave Configuration"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
